export default __webpack_public_path__ + "static/media/rulerOff.b074c438.svg";